import React from 'react';
import { Route, Switch } from 'react-router-dom';

import UpdateAssignedStudents from './UpdateAssignedStudents';
import EditUnitActivitiesContainer from './EditUnitActivitiesContainer.jsx';

import ChooseClassroomLesson from '../components/assignment_flow/choose_classroom_lesson';
import ClassroomLessonsPlanner from '../components/assignment_flow/classroom_lessons';
import ManageUnits from '../components/assignment_flow/manage_units/manage_units.tsx';
import MyActivitiesTabs from '../components/assignment_flow/my_activities_tabs.jsx';
import UnitTemplateProfile from '../components/assignment_flow/unit_templates_manager/unit_template_profile/unit_template_profile.tsx';
import UnitTemplatesManager from '../components/assignment_flow/unit_templates_manager/unit_templates_manager';

// react-router links to the planner routes never hit Teachers::ClassroomManagerController's redirect, so an opted-in teacher would otherwise land back on the legacy page
const RedirectToManageActivitiesV2 = ({ view }) => {
  React.useEffect(() => {
    window.location.replace(view === 'closed' ? '/teachers/classrooms/manage_activities_v2?view=closed' : '/teachers/classrooms/manage_activities_v2')
  }, [])
  return null
}

export default class LessonPlannerContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { user, location, children, unassignWarningHidden, showManageActivitiesV2OptInBanner, usesManageActivitiesV2, } = this.props
    const tabs = location.pathname.includes('teachers') ? <MyActivitiesTabs pathname={location.pathname} /> : <span />
    return (
      <div id="post-secondary-nav" tabIndex={-1}>
        {tabs}
        {children}
        <Switch>
          <Route component={ClassroomLessonsPlanner} path="/teachers/classrooms/activity_planner/lessons" />
          <Route component={ClassroomLessonsPlanner} path="/teachers/classrooms/activity_planner/lessons/:classroomId" />
          <Route component={ChooseClassroomLesson} path="/teachers/classrooms/activity_planner/lessons_for_activity/:activityId" />
          <Route path="/teachers/classrooms/activity_planner/units/:unitId/students/edit" render={routerProps => <UpdateAssignedStudents unassignWarningHidden={unassignWarningHidden} user={user} {...routerProps} />} />
          <Route component={EditUnitActivitiesContainer} path="/teachers/classrooms/activity_planner/units/:unitId/activities/edit" />
          <Route path="/teachers/classrooms/activity_planner/closed" render={routerProps => (usesManageActivitiesV2 ? <RedirectToManageActivitiesV2 view="closed" /> : <ManageUnits open={false} showManageActivitiesV2OptInBanner={showManageActivitiesV2OptInBanner} userId={user?.id} {...routerProps} />)} />
          <Route exact path="/teachers/classrooms/activity_planner" render={(routerProps) => ((usesManageActivitiesV2 && !new URLSearchParams(routerProps.location.search).has('tab')) ? <RedirectToManageActivitiesV2 /> : <ManageUnits open={true} showManageActivitiesV2OptInBanner={showManageActivitiesV2OptInBanner} userId={user?.id} {...routerProps} />)} />
          <Route component={UnitTemplateProfile} path="/activities/packs/:activityPackId" />
          <Route component={UnitTemplatesManager} path="/activities/packs" />
          <Route component={UnitTemplatesManager} path="/activities/packs/category/:category" />
          <Route component={UnitTemplatesManager} path="/activities/packs/grade/:grade" />
        </Switch>
      </div>
    )
  }
}
